<template>
    <div class="list-header">
        <div class="logo-box">
            <img src="../assets/img/issue.png" alt="logo">
        </div>
        <div class="header-mid">{{title}}</div>
    </div>
</template>

<script>
export default {
  name: 'PageTitle',
  props: {
    title: {
      type: String
    }
  }
}
</script>

<style lang="stylus" scoped>
  .list-header
    position relative
    height 45px
    background-color #fdbe31
    border-top 1px solid #ffffff
    .logo-box
      position absolute
      top 6px
      left 10px
      padding 2px
      height 29px
      width 29px
      background-color #ffffff
      border-radius 50%
      img
        max-width 100%
    .header-mid
      line-height 45px
      width 554px
      margin 0 auto
      text-align center
      font-size 18px
      color #ffffff
      font-weight 600
</style>



// WEBPACK FOOTER //
// src/components/PageTitle.vue